const rootReducer = () => {};

export default rootReducer;